"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.velocities = velocities;
exports.counts = counts;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _assert = require("@swarm2/assert");

var _util = require("../../../util");

var Util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Swarm-growth is written for Decimals, but combat uses non-Decimal numbers.
// Combat doesn't have parents-of-parents yet though - drone -> meat, but no
// queen -> drone - so we'll just write our own little growth function here.

function velocities(counts, producedByEach) {
  var ret = _lodash2.default.mapValues(counts, function () {
    return 0;
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(producedByEach)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var child = _step.value;

      var parents = producedByEach[child];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.keys(parents)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var parent = _step2.value;

          var prodEach = parents[parent];
          var parentCount = counts[parent] || 0;
          var prodTotal = prodEach * parentCount;
          // don't add zero-velocities to the result unnecessarily
          if (prodTotal !== 0) ret[child] = (ret[child] || 0) + prodTotal;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return ret;
}
function counts(counts0, producedByEach, dt) {
  if (_lodash2.default.isNaN(dt)) return (0, _assert.throws)("counts: bogus dt", dt);
  var vs = velocities(counts0, producedByEach);
  return _lodash2.default.mapValues(vs, function (v, name) {
    return Math.floor((counts0[name] || 0) + v * Util.Duration.seconds.to(dt));
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/combat/growth.js
// module id = 806
// module chunks = 0